import React, { useState,useEffect } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import axios from 'axios';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const KamModal = ({ open, onClose ,kamdata,campaignID,campaignKamID,getCampaignList}) => {
 
  const serverURL = process.env.REACT_APP_URL;

  const [selectedKam, setSelectedKam] = useState(campaignKamID ? [campaignKamID] : []);

  useEffect(() => {
    // Find the KAMs that match the IDs in campaignKamID
    if(open){
        const selectedKAMs = kamdata.filter((kam) =>
            campaignKamID.includes(kam._id)
          );
          setSelectedKam(selectedKAMs); // Initialize the selected KAMs
    }
  }, [open,kamdata, campaignKamID]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
  
    // `value` is an array, so you directly pass it to setSelectedKam
    setSelectedKam(value);
  };


  const handleAssign = async() => {
    const keyAccountManagerId = selectedKam.map((kam) => kam._id); // Extract _id values from selectedKam array

    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${serverURL}/campaign/assignAdmin/${campaignID}`,
        {keyAccountManagerId},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data?.success) {
        getCampaignList()
        onClose(false)
      }
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };

  
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <FormControl sx={{ m: 1, width: 300 }}>
          <InputLabel id="demo-multiple-checkbox-label">KAM</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={selectedKam}
            onChange={handleChange}
            input={<OutlinedInput label="KAM" />}
            renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value._id} label={value.name} />
                  ))}
                </Box>
              )}
            MenuProps={MenuProps}
          >
               {kamdata.map((kam)=>{
                return <MenuItem key={kam._id} value={kam}>
                    <Checkbox checked={selectedKam.some((selected) => selected._id === kam._id)} />
                     <ListItemText primary={kam.name} />
                </MenuItem>
            })}
            
          </Select>
        </FormControl>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button variant="contained" color="primary"  onClick={handleAssign}>
            Assign
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default KamModal;
